export const handleApiError = (
  error,
  snackbar,
  fallbackMessage = "Something went wrong."
) => {
  const status = error?.response?.status;
  const message = error?.response?.data?.error || fallbackMessage;

  if (status === 401 || status === 403) {
    snackbar.error("Your session has expired. Please log in again.");
  } else if (status === 404) {
    snackbar.error("Requested resource was not found.");
  } else if (status === 500) {
    snackbar.error("Server error. Please try again later.");
  } else if (error.message?.includes("Network Error")) {
    snackbar.error("No connection. Please check your internet.");
  } else if (error.message?.includes("CORS")) {
    snackbar.error("CORS error: Your session may have expired.");
  } else {
    snackbar.error(message);
  }

  console.error("API Error:", error);
};
